import { useCallback, useState } from 'react';
import Swal from 'sweetalert2';
import { apiUrl } from '../../config/api';
import { readAuth } from '../../hooks/useAuthStorage';

/**
 * Loads the cart contents, optionally applying a coupon and/or fast
 * delivery. `fetchCartProducts` is memoised because callers depend on
 * it from effects — an unmemoised version re-triggered the effect on
 * every render.
 */
const useCartContant = () => {
  const [cartproducts, setcartproducts] = useState({ cart_items: [], total_cart_value: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCartProducts = useCallback(async (coupon_id, fast_delivery, coupon_code) => {
    const { user_id, common_id } = readAuth();
    setLoading(true);

    try {
      const response = await fetch(apiUrl('/api/cart/items'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          common_id,
          user_id: parseInt(user_id, 10),
          coupon_id: coupon_id ? coupon_id : 'null',
          coupon_code: coupon_code ? coupon_code : 'null',
          fast_delivery: fast_delivery ? fast_delivery : false,
        }),
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();

      // Only warn about an invalid coupon when one was actually typed —
      // the old check fired on any cart load with items present.
      if (coupon_code && !data.valid_coupon && data.cart_items?.length > 0) {
        Swal.fire({
          icon: 'warning',
          confirmButtonColor: '#a17e33',
          title: 'Coupon not applied',
          text: `“${coupon_code}” is not valid for this order.`,
        });
      }

      setcartproducts(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return { cartproducts, loading, error, fetchCartProducts };
};

export default useCartContant;
